import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Modal, Button } from 'antd';
import { useEnviarEmailSimulacao } from '../../../../../services/repository/simuladorRepository';
import CalculadoraRE from '../../../../../services/CalculadoraRE';

function ModalEmailColaborador({
  isVisible,
  onOkClick,
  onCancelClick,
  calculadoraRE,
}) {
  const [form] = Form.useForm();
  const [enviarEmailSimulacao, { loading }] = useEnviarEmailSimulacao();
  const [hasInvalidItems, setHasInvalidItems] = useState();

  const handleFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    setHasInvalidItems(hasErrors);
  };

  const handleOkClick = async ({ email }) => {
    try {
      await enviarEmailSimulacao(email, calculadoraRE);
      Modal.success({
        title: 'Sucesso',
        content: 'E-mail enviado com sucesso',
        centered: true,
      });
    } catch (error) {
      Modal.error({
        title: 'Erro',
        content: 'Ocorreu um erro ao enviar o e-mail',
        centered: true,
      });
    } finally {
      onOkClick(email);
    }
  };

  return (
    <Modal
      title="Enviar e-mail para o colaborador"
      open={isVisible}
      centered
      onCancel={onCancelClick}
      confirmLoading={loading}
      cancelButtonProps={{ disabled: loading }}
      destroyOnClose
      footer={[
        <Button
          key="modal-email-colaborador-cancel"
          data-testid="modal-email-colaborador-cancel"
          disabled={loading}
          onClick={onCancelClick}
        >
          Cancelar
        </Button>,
        <Button
          key="modal-email-colaborador-submit"
          data-testid="modal-email-colaborador-submit"
          loading={loading}
          disabled={hasInvalidItems}
          form="envioEmailForm"
          type="primary"
          htmlType="submit"
        >
          Enviar
        </Button>,
      ]}
    >
      <Form
        onFieldsChange={handleFormChange}
        onFinish={handleOkClick}
        layout="vertical"
        id="envioEmailForm"
        form={form}
      >
        <Form.Item
          label="E-mail do colaborador"
          name="email"
          required
          rules={[
            // eslint-disable-next-line no-template-curly-in-string
            { type: 'email', message: '${label} não é um e-mail válido!' },
          ]}
        >
          <Input data-testid="modal-email-colaborador-email" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

ModalEmailColaborador.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onOkClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  calculadoraRE: PropTypes.instanceOf(CalculadoraRE).isRequired,
};

export default ModalEmailColaborador;
